import { cloneDeep, isEqual } from 'lodash';
import { isAIPage } from '@/loaders/page/helper';
import { DescriptionType, DiffType, getFormatDiffContent, } from './common';
import { getDetailedDiffTree, mergeDescriptions } from './getDetailedDiffTree';
/**
 * 忽略 AI 页面发布时的「仅元信息」字段后再比较（用于判断是否只有 creator / pageConfig.hash 变化）
 */
function stripAiPageIgnoredFields(page) {
    if (!page || typeof page !== 'object')
        return page;
    const next = cloneDeep(page);
    getFormatDiffContent(next);
    delete next.creator;
    if (next.pageConfig && typeof next.pageConfig === 'object') {
        delete next.pageConfig.hash;
    }
    return next;
}
/**
 * AI 页面、更新操作，且除 creator 与 pageConfig.hash 外无其它字段差异时返回 true（左侧树隐藏，发布时仍可随 AI 分组带上）
 */
export function isAIPageMetadataOnlyUpdate(item) {
    if (item.schemaKey !== 'page' || item.type !== DiffType.UPDATE)
        return false;
    if (!isAIPage(item.originData) && !isAIPage(item.compareData))
        return false;
    const strippedOrigin = stripAiPageIgnoredFields(item.originData);
    const strippedCompare = stripAiPageIgnoredFields(item.compareData);
    return isEqual(strippedOrigin, strippedCompare);
}
function dedupeSchemaDescriptions(arr) {
    const seen = new Set();
    return arr.filter((d) => {
        if (d.propType !== DescriptionType.Schema)
            return true;
        const k = `${d.schemaKey}:${d.id}`;
        if (seen.has(k))
            return false;
        seen.add(k);
        return true;
    });
}
/**
 * 为隐藏的仅元信息变更 AI 页面构造与 mergeDescriptions 一致的细粒度描述列表（单页对应树节点 key 为 ai-page:id）
 */
export function getHiddenAIPageMetadataDescriptions(hiddenItems, fieldOptions, mergeOptions) {
    const merged = [];
    hiddenItems.forEach((item) => {
        const { descriptionMap } = getDetailedDiffTree(cloneDeep([item]), fieldOptions);
        const key = `ai-page:${item.id}`;
        if (!descriptionMap[key])
            return;
        merged.push(...mergeDescriptions([key], descriptionMap, mergeOptions));
    });
    return dedupeSchemaDescriptions(merged);
}
